/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as Styles from '../../../../../SharedModules/StyleConstant/StyleConstant';
import MaxLengthNumericEditor from '../../../../../SharedModules/CustomAgGridEditor/inputComponent';

export const TableHeaderForManufacturer = [
  {
    headerName: 'Select All',
    maxWidth: Styles.Width_150,
    headerCheckboxSelection: true, // For header check box
    checkboxSelection: true,
    filter: false,
    field: 'checkSelect',
    editable: false,
    suppressMenu: true,
    sortable: false,
    pdfExportOptions: {
      skipColumn: true,
    },
    cellStyle: { 'border-right-color': Styles.BorderColor },
  },
  {
    headerName: 'Manufacturer ID',
    field: 'mfgId',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: false,
    sort: 'asc',
    maxWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Manufacturer Name',
    field: 'mfgName',
    editable: false,
    sortable: true,
    resizable: false,
    suppressMenu: false,
    minWidth: Styles.Width_600,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];
